import { render, staticRenderFns } from "./msw-supportcases-widget.vue?vue&type=template&id=7f58bb9a&"
import script from "./msw-supportcases-widget.vue?vue&type=script&lang=tsx&"
export * from "./msw-supportcases-widget.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-supportcases-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports